/**
 * @copyright (C) 2023, Rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of Rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by Rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/
/* eslint prefer-const: 0 */
/* eslint no-constant-condition: 0 */
/* eslint @typescript-eslint/no-explicit-any: 0 */

class CacheDataPrivateStatic implements Storage {
	constructor(
		private _cache = new Map<string, any>()
	) {}

	public get length() { return this._cache.size; }
	public clear() {
		this._cache.clear();
	}
	public key(index: number) {
		const keys = this._cache.keys();
		let result = "";
		let count = 0;
		do {
			result = keys.next().value;
			if (count === index) {
				break;
			}
		} while (true);
		return result;
	}

	public setItem<T>(key: string, value: T) {
		this._cache?.set(key, value);
	}

	public getItem(key: string) {
		if (this._cache?.has(key)) {
			return this._cache?.get(key);
		}
		return undefined;
	}

	public removeItem(key: string) {
		if (this._cache?.has(key)) {
			this._cache.delete(key);
		}
	}
};

const CacheDataPrivate = new CacheDataPrivateStatic();
export default CacheDataPrivate;
